import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ListGroup, Row, Col, Card, Navbar } from 'react-bootstrap'

import Meta from '../components/Meta'



import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

  


export const CustomNodesScreen = ({match, history}) => {
    const dispatch = useDispatch()
    const [selectedSection, setSelectedSection] = useState("") 
    const [data, setData] = useState([])
    const [viewMode, setViewMode] = useState('whatislaeyerz')

    useEffect(() => {}, [])

    return(
        
        <div style={{margin:"10px", padding:"10px"}}>
            <Meta title={'Building Custom Nodes'} description={'Building custom nodes with Laeyerz'}/>
            
            <Navbar></Navbar>

           

                <section id='openai-node' style={{marginBottom:'10px'}}>

                <Card style={{border:"None"}}>
                        <Card.Header style={{border:"None"}}>
                            <p className='h4'>Creating a Custom Node</p>

                        </Card.Header>
                        <Card.Body>
                            Creating custom workflows requires creating custom nodes.

                        </Card.Body>
                    </Card>

                    <Card style={{border:"None"}}>
                        <Card.Header style={{border:"None"}}>
                            <p className='h4'>Configure the Node</p>

                        </Card.Header>
                        <Card.Body>
                            Add the API key.
                            Select the action.
                            Pick the relevant parameters.

                        </Card.Body>
                    </Card>

                </section>
                            



 
        </div>
    )
}

export default CustomNodesScreen


